import PropTypes from "prop-types"
import Input from "./Input"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { emailChecker } from "../../helpers/email"
import Select from "./Select"
import useCaptchaValidation from "../../hooks/useCaptchaValidation"
import ReCAPTCHA from "react-google-recaptcha"

const Form = styled.form`
  display: flex;
  flex-direction: column;
`

const Button = styled.button`
  background: #112149;
  color: white;
  border: 0;
  align-self: flex-end;
  margin: 10px;
  padding-inline: 10px;
  padding-block: 5px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`

const Error = styled.div`
  background: white;
  border: 1px solid red;
  padding: 10px;
  margin-bottom: 10px;

  & > span {
    color: red;
  }
`

const Warning = styled.div`
  background: white;
  border: 1px solid darkorange;
  padding: 10px;
  margin-bottom: 10px;

  & > span {
    color: darkorange;
  }
`

export const NonAssociateInscriptionForm = props => {
  const {
    courseId,
    requestTrigger,
    computableHours,
    capacity,
    attendants,
    setSuccessMessage,
    handleClose,
  } = props
  const {
    captchaRef,
    captchaError,
    validateCaptcha,
    resetCaptchaError,
    showCaptchaError,
    resetCaptcha,
  } = useCaptchaValidation();
  const [howKnowOptions, setHowKnowOptions] = useState([])
  const [nonAssociateName, setNonAssociateName] = useState("")
  const [nonAssociateSecondName, setNonAssociateSecondName] = useState("")
  const [nonAssociateDNI, setNonAssociateDNI] = useState("")
  const [nonAssociateEmail, setNonAssociateEmail] = useState("")
  const [nonAssociateTelephone, setNonAssociateTelephone] = useState("")
  const [nonAssociateCompany, setNonAssociateCompany] = useState("")

  const [errorMessage, setErrorMessage] = useState("")

  const handleChangeNonAssociateName = e => setNonAssociateName(e.target.value)
  const handleChangeNonAssociateSecondName = e =>
    setNonAssociateSecondName(e.target.value)
  const handleChangeNonAssociateDNI = e => setNonAssociateDNI(e.target.value.toUpperCase())
  const handleChangeNonAssociateEmail = e =>
    setNonAssociateEmail(e.target.value)
  const handleChangeNonAssociateTelephone = e =>
    setNonAssociateTelephone(e.target.value)
  const handleChangeNonAssociateCompany = e =>
    setNonAssociateCompany(e.target.value)

  const getHowKnowOptions = () => {
    requestTrigger({
      url: "courses/how-know/?list_active",
      method: "GET",
    }).then(({ data }) => data.length && setHowKnowOptions(data))
  }

  const handleSubmit = e => {
    e.preventDefault()
    setErrorMessage("")
    if (e.target[0].value.length === 0) {
      setErrorMessage("Escribir un nombre es obligatorio.")
      return
    }
    if (e.target[1].value.length === 0) {
      setErrorMessage("Escribir los apellidos es obligatorio.")
      return
    }
    if (e.target[2].value.length === 0) {
      setErrorMessage("Escribir el DNI es obligatorio.")
      return
    }
    if (!emailChecker(e.target[3].value)) {
      setErrorMessage("Escribe un email válido.")
      return
    }
    if (e.target[4].value.length === 0 || /[a-zA-Z]/g.test(e.target[4].value)) {
      setErrorMessage("Escribe un número de teléfono válido.")
      return
    }
    if (e.target[5].value.length === 0) {
      setErrorMessage("Escribir la empresa es obligatorio.")
      return
    }

    resetCaptchaError();
    if (!validateCaptcha()) {
      showCaptchaError();
      return;
    }

    requestTrigger({
      url: `courses/attendants-non-associate/`,
      method: "POST",
      data: {
        course: courseId,
        name: e.target[0].value,
        second_name: e.target[1].value,
        person_identity_number: e.target[2].value.toUpperCase(),
        email: e.target[3].value,
        computable_hours: computableHours,
        telephone_number: e.target[4].value,
        company_name: e.target[5].value,
        how_knows: e.target[6].value,
      },
    })
      .then(({ data }) => {
        if (data) {
          setSuccessMessage("Te has inscrito correctamente.")
          handleClose()
        }
      })
      .catch(err => {
        resetCaptcha();
        setErrorMessage(JSON.stringify(err.response.data))
      })
  }

  useEffect(() => getHowKnowOptions(), [])

  const inputDisabled = attendants === capacity

  return (
    <Form onSubmit={handleSubmit}>
      {errorMessage.length > 0 && (
        <Error>
          <span>{errorMessage}</span>
        </Error>
      )}
      {inputDisabled && (
        <Warning>
          <span>Inscripción cerrada por aforo completo.</span>
        </Warning>
      )}
      <Input
        label="Nombre"
        defaultValue={nonAssociateName}
        onChange={handleChangeNonAssociateName}
        disabled={inputDisabled}
        required
      />
      <Input
        label="Apellidos"
        defaultValue={nonAssociateSecondName}
        onChange={handleChangeNonAssociateSecondName}
        disabled={inputDisabled}
        required
      />
      <Input
        label="DNI"
        defaultValue={nonAssociateDNI}
        onChange={handleChangeNonAssociateDNI}
        disabled={inputDisabled}
        required
      />
      <Input
        label="Email"
        defaultValue={nonAssociateEmail}
        onChange={handleChangeNonAssociateEmail}
        disabled={inputDisabled}
        required
      />
      <Input
        label="Teléfono"
        defaultValue={nonAssociateTelephone}
        onChange={handleChangeNonAssociateTelephone}
        disabled={inputDisabled}
        type="tel"
        required
      />
      <Input
        label="Empresa"
        defaultValue={nonAssociateCompany}
        onChange={handleChangeNonAssociateCompany}
        disabled={inputDisabled}
        required
      />
      <Select
        options={howKnowOptions}
        keyField="pk"
        labelField="title"
        label="¿Cómo has conocido este evento?"
        name="how_know"
      />
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginLeft: 20 }}>
        <ReCAPTCHA
          sitekey={process.env.GATSBY_CAPTCHA_KEY}
          ref={captchaRef}
          size="normal"
        />
      </div>
      {captchaError && (
        <span style={{ color: "red" , width: '100%', textAlign: "center"}}>
            Por favor, complete el captcha
          </span>
      )}
      <Button type="submit" disabled={inputDisabled}>
        {" "}
        Inscribirme
      </Button>
    </Form>
  )
}

NonAssociateInscriptionForm.propTypes = {
  onSubmit: PropTypes.func,
}
